'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getAreaRouteParams = exports.getBuilder = exports.getAreas = exports.getSubMetro = exports.getMetro = exports.getArea = undefined;

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _extends3 = require('babel-runtime/helpers/extends');

var _extends4 = _interopRequireDefault(_extends3);

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

var _lodash = require('lodash');

var _reselect = require('reselect');

var _bdcoreNamedRoutes = require('@bd/bdcore-named-routes');

var _bdcoreUtilities = require('@bd/bdcore-utilities');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var routeParamsToPropsMap = {
  communityMarketAreaSubMetro: 'name',
  communityMarketAreaMetro: 'name',
  communityMarketArea: 'name'
};

var getArea = exports.getArea = (0, _reselect.createSelector)([function (_ref, _ref2) {
  var _ref$cloudData = _ref.cloudData;
  _ref$cloudData = _ref$cloudData === undefined ? {} : _ref$cloudData;
  var builder = _ref$cloudData.builder;
  var _ref2$builderId = _ref2.builderId,
      builderId = _ref2$builderId === undefined ? _bdcoreUtilities.ConfigStore.getConfig('builder_id') : _ref2$builderId;
  return (0, _lodash.get)(builder, builderId + '.data.products.BDWebsite.data.areas', []);
}, function (_ref3) {
  var filters = _ref3.filters;
  return filters;
}, function (state, params) {
  return params;
}], function (areas, filters, _ref4) {
  var match = _ref4.match,
      name = _ref4.name,
      overrideRouteParamsMap = _ref4.overrideRouteParamsMap;

  if (match && (0, _keys2.default)(match.params).length === 0) {
    return undefined;
  }

  var params = (0, _keys2.default)(overrideRouteParamsMap || routeParamsToPropsMap).reduce(function (result, key) {
    if ((0, _lodash.get)(match, 'params.' + key)) {
      return (0, _extends4.default)({}, result, (0, _defineProperty3.default)({}, key, (0, _lodash.get)(match, 'params.' + key)));
    }

    return result;
  }, {});

  var area = areas.reduce(function (result, item) {
    if (result.name === undefined && (name !== undefined && item.name === name || match && (0, _bdcoreNamedRoutes.paramsMatch)(params, overrideRouteParamsMap || routeParamsToPropsMap, item, true))) {
      return item;
    }

    return result;
  }, {});

  if (area && area.isMetro) {
    area.subMetros = areas.filter(function (subarea) {
      return subarea && !subarea.isMetro && subarea.parentMetro === area.name;
    }).map(function (subarea) {
      return subarea.name;
    });
  }

  return area.name ? area : undefined;
});

var getMetro = exports.getMetro = function getMetro(state, params) {
  return getArea(state, (0, _extends4.default)({}, params, {
    overrideRouteParamsMap: {
      communityMarketAreaMetro: 'name'
    }
  }));
};

var getSubMetro = exports.getSubMetro = function getSubMetro(state, params) {
  return getArea(state, (0, _extends4.default)({}, params, {
    overrideRouteParamsMap: {
      communityMarketAreaSubMetro: 'name'
    }
  }));
};

var getAreas = exports.getAreas = function getAreas(_ref5) {
  var _ref5$cloudData = _ref5.cloudData;
  _ref5$cloudData = _ref5$cloudData === undefined ? {} : _ref5$cloudData;
  var builder = _ref5$cloudData.builder;
  var props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var metros = props.metros,
      _props$builderId = props.builderId,
      builderId = _props$builderId === undefined ? _bdcoreUtilities.ConfigStore.getConfig('builder_id') : _props$builderId,
      all = props.all;


  var areas = (0, _lodash.get)(builder, builderId + '.data.products.BDWebsite.data.areas', []);

  if (all) {
    return areas.map(function (area) {
      if (area && area.isMetro) {
        return (0, _extends4.default)({}, area, {
          subMetros: areas.filter(function (subarea) {
            return subarea && !subarea.isMetro && subarea.parentMetro === area.name;
          }).map(function (subarea) {
            return subarea.name;
          })
        });
      }

      return area;
    });
  }

  if (metros) {
    return areas.filter(function (area) {
      return area && area.isMetro;
    }).map(function (area) {
      return (0, _extends4.default)({}, area, {
        subMetros: areas.filter(function (subarea) {
          return subarea && !subarea.isMetro && subarea.parentMetro === area.name;
        }).map(function (subarea) {
          return subarea.name;
        })
      });
    });
  }

  return areas;
};

var getBuilder = exports.getBuilder = function getBuilder(_ref6, _ref7) {
  var _ref6$cloudData = _ref6.cloudData;
  _ref6$cloudData = _ref6$cloudData === undefined ? {} : _ref6$cloudData;
  var builder = _ref6$cloudData.builder;
  var _ref7$builderId = _ref7.builderId,
      builderId = _ref7$builderId === undefined ? _bdcoreUtilities.ConfigStore.getConfig('builder_id') : _ref7$builderId;
  return (0, _lodash.get)(builder, builderId + '.data');
};

var getAreaRouteParams = exports.getAreaRouteParams = function getAreaRouteParams(community, state) {
  return (0, _bdcoreNamedRoutes.getPropsFromItem)(community, routeParamsToPropsMap, true, state);
};

exports.default = getArea;


//////////////////
// WEBPACK FOOTER
// ./~/@bd/bdcore-data/build/Builder/selectors.js
// module id = 118
// module chunks = 0